export enum ActorAssemblerConstant {
	OBJECT_3D = 'this.object3D',
	MATERIAL = 'this.object3D.material',
	GEOMETRY = 'this.object3D.geometry',
	PTNUM = 'this.ptnum',
	PRIMITIVE_GRAPH = 'null',
}
